import { put, call, takeLeading, select } from 'redux-saga/effects'
import { types, IGetLanguagesStartedAction } from '../types/languages'
import * as actions from '../actions/languages'
import * as services from '../services/languages'
import { selectLanguages } from '../selectors/languages'
import { trace } from '../services/common'

export function* getLanguagesSaga(action: IGetLanguagesStartedAction) {
  try {
    const { list } = yield select(selectLanguages)
    if (!list.length) {
      const languagesList = yield call(services.getLanguages)
      yield put(actions.getLanguagesSuccess(languagesList))
    } else {
      yield put(actions.getLanguagesCancel())
    }
  } catch (err) {
    yield put(actions.getLanguagesFailure(err.message))
    trace(err)
  }
}

export function* languagesWatcher() {
  yield takeLeading(types.GET_LANGUAGES__STARTED, getLanguagesSaga)
}
